"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePanel = void 0;
const react_1 = __importStar(require("react"));
require("./types");
const getDefaultOptions = () => {
    return {};
};
const usePanel = ({ formConfig, showError, setDisabledWizardActions, closingConfirmationDialogActions, panels, extraData, }) => {
    const [isActive, setActive] = react_1.useState(false);
    const [canClosePanel, setClosePanel] = react_1.useState(true);
    const [currentPanel, setCurrentPanel] = react_1.useState(null);
    const [options, setOptions] = react_1.useState(() => getDefaultOptions());
    const setCanClosePanel = (value) => {
        setClosePanel(value);
    };
    const showPanel = (panel, panelOptions) => {
        if (currentPanel !== panel) {
            setCurrentPanel(panel);
        }
        setActive(true);
        setClosePanel(true);
        setDisabledWizardActions(true);
        setOptions(panelOptions ? panelOptions : getDefaultOptions());
    };
    const deactivate = () => {
        setActive(false);
        setCurrentPanel(null);
        setDisabledWizardActions(false);
    };
    const closePanelWithConfirm = (isExitWizard, message) => {
        if (canClosePanel) {
            deactivate();
            return;
        }
        closingConfirmationDialogActions.show({
            isExitWizard,
            message,
            onDoneCallback: () => {
                deactivate();
            },
        });
    };
    const getCurrentPanel = (panel) => {
        if (!panel) {
            return null;
        }
        const PanelComponent = panels[panel];
        if (!PanelComponent) {
            return null;
        }
        return react_1.default.createElement(PanelComponent, {
            formConfig,
            isActive,
            closePanel: deactivate,
            closePanelWithConfirm,
            setCanClosePanel,
            showError,
            options,
            extraData,
        });
    };
    const body = getCurrentPanel(currentPanel);
    const actions = {
        isActive,
        currentPanel,
        showPanel,
        closePanel: deactivate,
        closePanelWithConfirm,
        setCanClosePanel,
    };
    const meta = {
        panelWidth: options === null || options === void 0 ? void 0 : options.panelWidth,
        panelMinWidth: options === null || options === void 0 ? void 0 : options.panelMinWidth,
    };
    return [body, actions, meta];
};
exports.usePanel = usePanel;
//# sourceMappingURL=usePanel.js.map